export default __webpack_public_path__ + "static/media/whust_icon.b71877ef.svg";